import { CookieService } from 'ngx-cookie-service';
import { Inject, Injectable } from '@angular/core';
import type { LocaleInput } from '@fullcalendar/angular';
import ptCalendar from 'fullcalendar/locales/pt';
import enGbCalendar from 'fullcalendar/locales/en-gb';
import esCalendar from 'fullcalendar/locales/es';
import angularPt from '@angular/common/locales/pt';
import angularEs from '@angular/common/locales/es';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

// Angular's registerLocaleData accepts `any`; each locale's default export has
// a slightly different generated type (different currency maps), so there is no
// single concrete type that covers all of them.

type AngularLocaleData = any;

interface LocaleDefinition {
  key: string;
  angular?: AngularLocaleData;
  calendar?: LocaleInput;
}

const locales: LocaleDefinition[] = [
  { key: 'en', calendar: enGbCalendar },
  { key: 'pt', angular: angularPt, calendar: ptCalendar },
  { key: 'es', angular: angularEs, calendar: esCalendar },
];

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  static readonly DEFAULT_LANGUAGE = 'pt';

  static readonly supportedLanguages = locales.map((l) => l.key);

  static readonly angularLocales = locales
    .map((l) => l.angular)
    .filter((l) => l != null);

  static readonly calendarLocales = locales
    .map((l) => l.calendar)
    .filter((l) => l != null);

  private static readonly LANGUAGE_COOKIE_KEY = 'lang';

  constructor(
    private cookieService: CookieService,
    @Inject(I18NEXT_SERVICE) private i18next: ITranslationService,
  ) {}

  public getCurrentLanguage(): string {
    return (
      this.cookieService.get(LocaleService.LANGUAGE_COOKIE_KEY) ||
      LocaleService.DEFAULT_LANGUAGE
    );
  }

  public setLanguage(language: string): Promise<void> {
    return this.i18next.changeLanguage(language).then(() => {
      this.cookieService.set(LocaleService.LANGUAGE_COOKIE_KEY, language);
    });
  }
}
